import AuditModel from './AuditModel'

export default class AuditListModel {
  constructor (data) {
    if (Array.isArray(data)) {
      this.list = this.groupBy(data, 'entityTypeName')
      this.categories = Object.keys(this.list)
    }
  }

  groupBy (array, key) {
    /**
     * data = [{ name: "A", value: "1"}, { name: "A", value: "2"}]
     * groupBy(data, "name") => { A: [{ name: "A", value: "1"}, { name: "A", value: "2"}] }
     */
    return array.reduce((result, item) => {
      (result[item[key]] = result[item[key]] || []).push(new AuditModel(item))
      return result
    }, {})
  }
}



// WEBPACK FOOTER //
// ./src/api/audit/AuditListModel.js